import React from "react";
import cx from "./cx";

/**
 * Barra inferior sticky de acciones.
 *  - sangre: a sangre respecto al padding del lienzo (.rev-page): mismo ancho que el
 *    footer y pegada a el al final del scroll
 *  - error / ok: mensaje con icono a la izquierda
 *  - left: cualquier otro nodo a la izquierda (un aviso, por ejemplo)
 *  - children: los botones (.rev-barra__actions)
 */
const RevBarra = ({ sangre, error, ok, left, className, children, ...rest }) => (
    <div className={cx('rev-barra', sangre && 'rev-barra--sangre', className)} {...rest}>
        {error &&
            <span className="rev-barra__error">
                <span className="material-icons rev-icon-sm">error</span>
                {error}
            </span>}
        {ok &&
            <span className="rev-barra__ok">
                <span className="material-icons rev-icon-sm">check</span>
                {ok}
            </span>}
        {left}
        <div className="rev-barra__actions">{children}</div>
    </div>
);

export default RevBarra;
